import React from 'react';

interface SaveButtonProps {
  onClick: () => Promise<void>;
  disabled?: boolean;
  className?: string;
  hasChanges: boolean;
}

export const SaveButton: React.FC<SaveButtonProps> = ({
  onClick,
  disabled = false,
  className = '',
  hasChanges
}) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const isMounted = React.useRef(true);

  React.useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleClick = async () => {
    if (isLoading || disabled) return;
    
    setIsLoading(true);
    try {
      await onClick();
    } finally {
      // Only update state if component is still mounted
      if (isMounted.current) {
        setIsLoading(false);
      }
    }
  };

  const baseClassName = `px-3 py-1 text-sm rounded-md transition-colors duration-200 ${className}`;
  const enabledClassName = hasChanges
    ? 'bg-blue-600 text-white hover:bg-blue-700'
    : 'bg-gray-300 text-gray-500 cursor-not-allowed dark:bg-gray-700 dark:text-gray-400';

  return (
    <button
      onClick={handleClick}
      disabled={disabled || isLoading || !hasChanges}
      className={`${baseClassName} ${enabledClassName}`}
    >
      {isLoading ? (
        <span className="inline-flex items-center">
          <span className="opacity-0">Save</span>
          <span className="absolute left-1/2 transform -translate-x-1/2">
            Saving...
          </span>
        </span>
      ) : (
        'Save'
      )}
    </button>
  );
}; 